<div class="filter__container">
  <mat-form-field appearance="outline">
    <mat-label class="filter__title">{{ titel | translate }}</mat-label>
    <input
      matInput
      [placeholder]='titel | translate'
      [(ngModel)]="educationInput"
      (keydown.enter)="add()"
      [matChipInputFor]='grid'
    />
    <mat-chip-grid #grid>
      @for (filter of filterType; track filter; let idx = $index) {
        <mat-chip-row class='userlist__sidenav_chips' (removed)="delete(idx)">
          {{ filter }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
  </mat-form-field>
  <mat-checkbox [(ngModel)]='filterMode'>{{ 'userlist.filter.some' | translate }}</mat-checkbox>
</div>
